import {
  NotificationService,
  useNotificationService,
} from "./useNotificationService";

export type { NotificationService };

export { useNotificationService };
